// Initialize window._env_ if it doesn't exist
if (typeof window !== 'undefined' && !window._env_) {
  window._env_ = {};
}

export const RestfulUrls = {
  BASE_URL: (window._env_ && window._env_.RTRT_APP_BASE_URL) || "http://localhost:8000/server/", // Base backend url from env

  // Login
  GET_USER_DETAILS: "user/details",
  SUBMIT_USER_REQUEST: "user/request",

  // Transcriptions
  EDIT_SPEAKER: "speaker/",
  DELETE_SPEAKER: "speaker/",

  //Meetings
  CREATE_MEETING: "meeting-setup/create",
  MEETING_LIST: "meeting-setup/list",
  UPDATE_MEETING: "meeting-setup/update",
  GET_ZOOM_MEETING_DETAILS: "dashboard/details/",
  DELETE_MEETING: "meeting-setup/delete",
  RESET_AGENDA_SUMMARIES: "meeting-setup/reset-agenda-summaries",

  //Dashboard
  GET_MEETINGS: "dashboard/list",

  //Intervention Label Management : START
  ADD_INTERVENTION_LABEL: "intervention-labels/add",
  EDIT_INTERVENTION_LABEL: "intervention-labels/update",
  DELETE_INTERVENTION_LABEL: "intervention-labels/delete",
  INTERVENTION_LABEL_LIST: "intervention-labels/labels",
  PAGINATED_INTERVENTIONS: "intervention-labels/get-labels",
  UPDATE_INTERVENTION_ORDER: "intervention-labels/update-order",
  //Intervention Label Management : END

  //Intervention Summary Management : START
  UPDATE_INTERVENTION_SUMMARY: "realtime-reporting/intervention-summary/update",
  DELETE_INTERVENTION_SUMMARY: "realtime-reporting/intervention-summary/delete",
  IMPROVE_MEETING_PERFORMANCE: "realtime-reporting/improve-meeting-performance",
  //Intervention Summary Management : END
  //Terminology/Acronym Management : START
  ADD_ACRONYM: "terminology/add",
  EDIT_ACRONYM: "terminology/update",
  DELETE_ACRONYM: "terminology/delete",
  ACRONYM_LIST: "terminology/acronyms",
  PAGINATED_ACRONYMS: "terminology/get-acronyms",
  //Terminology/Acronym Management : END

  //User Management : START
  CREATE_USER: "users",
  GET_ALL_USERS: "users",
  UPDATE_USER_ROLE: "users/",
  DELETE_USER: "users/",
  TOGGLE_USER_STATUS: "users/",
  //User Management : END

  //Downloads
  DOWNLOAD_DESKTOP_TOOL: "download/desktop-tool",
};
